import Peanuts from "./Peanuts.jsx";
export default Peanuts